import "../components/productPrice.scss";
import emptyStar from "../imgs/emptyStar.svg";
import star from "../imgs/star.svg";
import { useState } from "react";
const ProductPrice = ({ title, img, price, offer }) => {
  let originalPrice = useState(
    parseInt(price) * (parseInt(offer) / 100) + parseInt(price)
  );

  return (
    <div className=" product">
      <div className="img__wrapper">
        <img className="cat__img" src={img} alt={title}></img>
      </div>
      <p class="productt__title">{title}</p>
      <li className="reviews">
        <img src={star} alt="stars" />
        <img src={star} alt="stars" />
        <img src={star} alt="stars" />
        <img src={star} alt="stars" />
        <img src={star} alt="stars" />
        <span>15,000</span>
      </li>
      <h4 className="price__tag">{price} EGP</h4>
      <p>
        {originalPrice}
        <span>{offer}% OFF</span>
      </p>
      <p>
        Arrives <b>Wed,May 4 </b>
      </p>
      <button>Add to basket</button>
    </div>
  );
};

export default ProductPrice;
